import { Node, Element, Transforms, Editor } from 'slate';
import { isDividingLineNode, isNodeEmptyDefaultBlock } from '../../utils/slateNodeHelper';
import { CustomSlateNodeType } from '../../types';

function withDividingLinde(editor: Editor) {
  const dividingLineEditor = editor;
  const { isInline, isVoid, normalizeNode } = editor;

  dividingLineEditor.isVoid = (element) => {
    return element.type === CustomSlateNodeType.DIVIDING_LINE ? true : isVoid(element);
  };

  dividingLineEditor.isInline = (element) => {
    return element.type === CustomSlateNodeType.DIVIDING_LINE ? false : isInline(element);
  };

  dividingLineEditor.normalizeNode = (entry) => {
    const [node, path] = entry;
    if (Element.isElement(node) && node.type === CustomSlateNodeType.DIVIDING_LINE) {
      const prevFirstNumber = path[0] - 1;
      const nextFirstNumber = path[0] + 1;
      // 如果分割线是第一个元素,在分割线前面添加一个空块
      if (!Node.has(editor, [prevFirstNumber])) {
        Transforms.insertNodes(
          editor,
          {
            type: CustomSlateNodeType.PARAGRAPH,
            children: [{ text: '' }],
          },
          {
            at: [0],
          },
        );
        return;
      }
      // 如果分割线是最后一个元素,那么后面需要加上一个空块
      if (
        !Node.has(editor, [nextFirstNumber]) ||
        (Node.get(editor, [nextFirstNumber]) as any).type === CustomSlateNodeType.IMAGE
      ) {
        Transforms.insertNodes(
          editor,
          {
            type: CustomSlateNodeType.PARAGRAPH,
            children: [{ text: '' }],
          },
          {
            at: [nextFirstNumber],
          },
        );
        return;
      }
      // 如果分割线前面是一个分割线或者空块,那么该分割线删除
      if (Node.has(editor, [prevFirstNumber])) {
        const prevNode = Node.get(editor, [prevFirstNumber]);
        if (isDividingLineNode(prevNode as any) || isNodeEmptyDefaultBlock(prevNode as any)) {
          Transforms.delete(editor, { at: path });
          return;
        }
      }
    }
    normalizeNode(entry);
  };

  return dividingLineEditor;
}

export default withDividingLinde;
